var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var LoginIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 5.56522C46.5809 5.56522 58.4348 17.4191 58.4348 32C58.4348 46.5809 46.5809 58.4348 32 58.4348C20.8295 58.4348 11.2594 51.4774 7.39383 41.6667H1.48672C5.58608 54.6133 17.6994 64 32 64C49.6696 64 64 49.6696 64 32C64 14.3304 49.6696 0 32 0C17.9461 0 6.00457 9.06572 1.70595 21.6667H7.66714C11.6967 12.2089 21.0842 5.56522 32 5.56522ZM44.3333 29.6683L31.9214 17.2557C30.88 16.2143 29.1916 16.2143 28.1502 17.2557C27.1088 18.2971 27.1088 19.9855 28.1502 21.0269L36.0098 28.8872L1.25 28.8872L1.25 34.2206H36.0098L28.1502 42.0802C27.1088 43.1216 27.1088 44.8101 28.1502 45.8514C29.1916 46.8928 30.88 46.8928 31.9214 45.8514L44.3333 33.4395C45.3747 32.3981 45.3747 30.7097 44.3333 29.6683Z"
  }));
};
export var LoginIconGlyph = function (props) {
  return React.createElement(LoginIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};